import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useSeo } from '../hooks/useSeo'
import { useT } from '../i18n'
import { useShopConfig } from '../shopConfig'

/**
 * Die 404-Seite — mit Ausgängen statt einer Sackgasse.
 *
 * Wer hier landet, hat meist einen alten Verweis geklickt oder sich vertippt.
 * Er soll nicht zurückgehen müssen, sondern von hier aus weiterkommen.
 */
export function NotFoundPage({ was }: { was?: string }) {
  const t = useT()
  const { shopName, primaryHost } = useShopConfig()

  useSeo({
    title: t('nichtGefunden.seoTitel', { laden: shopName }),
    description: t('nichtGefunden.seoText'),
    canonicalHost: primaryHost,
  })

  // Eine Clientanwendung kann den Status 404 nicht selbst senden — der Server
  // hat die Seite bereits mit 200 ausgeliefert. Damit eine tote Adresse
  // trotzdem nicht in den Index wandert, wird sie ausdrücklich ausgenommen.
  useEffect(() => {
    const tag = document.createElement('meta')
    tag.setAttribute('name', 'robots')
    tag.setAttribute('content', 'noindex')
    document.head.appendChild(tag)
    return () => tag.remove()
  }, [])

  return (
    <>
      <h1>{t('nichtGefunden.titel')}</h1>
      <p className="beschreibung">
        {was ?? t('nichtGefunden.standard')} {t('nichtGefunden.text')}
      </p>
      <p>
        <Link to="/">{t('nichtGefunden.zurStartseite')}</Link> ·{' '}
        <Link to="/sammlung">{t('nichtGefunden.zuSammlungen')}</Link> ·{' '}
        <Link to="/suche">{t('nichtGefunden.alleProdukte')}</Link>
      </p>
    </>
  )
}
